import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { FormattedMessage } from "react-intl";


export interface AddEdgeDeviceFormProps {
    parentId: string;
    parentResouceGroupId: string;
    edgeDeviceId: string;
    onEdgeDeviceIdChanged: any;
    description: string;
    onDescriptionChanged: any;
}
const AddEdgeDeviceForm = ({ parentId, parentResouceGroupId, edgeDeviceId, onEdgeDeviceIdChanged, description, onDescriptionChanged }: AddEdgeDeviceFormProps) => {

    return (
        <>
        <FormControl
            label= {<FormattedMessage id="Devices.EdgeDeviceID" defaultMessage="EdgeDeviceID" />}
            caption={<FormattedMessage id="Devices.TextEdgeDeviceID" defaultMessage="Enter the name of the IoT Edge Device as defined in your IotHub" />}
        >
            <Input autoFocus value={edgeDeviceId} onChange={onEdgeDeviceIdChanged} required />
        </FormControl>
         <FormControl
         label={<FormattedMessage id="Devices.Description" defaultMessage="Description" />}
         caption={<FormattedMessage id="Devices.TextDescription" defaultMessage="Enter the description" />}
     >
         <Input value={description} onChange={onDescriptionChanged} required  />
     </FormControl>
     </>
    )
}

export default AddEdgeDeviceForm;